module.exports = __webpack_public_path__ + "static/img/bulibuli.0212717e.png";